export default __webpack_public_path__ + "static/media/angellist.173b8475.svg";